import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	settings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.settings',
		defaultMessage: 'Project settings',
		description: 'Navigation item which links to a project settings page',
	},
	details: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.details',
		defaultMessage: 'Details',
		description: 'Settings navigation menu link for a service project',
	},
	people: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.people',
		defaultMessage: 'People',
		description: 'Settings navigation menu link for a service project',
	},
	itsmFeatures: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.itsm-features',
		defaultMessage: 'Features',
		description: 'Settings navigation menu link for a service project',
	},
	summary: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.summary',
		defaultMessage: 'Summary',
		description: 'Settings navigation menu link for a service project',
	},
	deleteProject: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.delete-project',
		defaultMessage: 'Delete project',
		description: 'Settings navigation menu link for a service project',
	},
	issueTypes: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-types',
		defaultMessage: 'Issue types',
		description: 'Settings navigation menu link for a service project',
	},
	issueLayout: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-layout',
		defaultMessage: 'Issue layout',
		description: 'Settings navigation menu link for a service project',
	},
	workflows: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.workflows',
		defaultMessage: 'Workflows',
		description: 'Settings navigation menu link for a service project',
	},
	screens: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.screens',
		defaultMessage: 'Screens',
		description: 'Settings navigation menu link for a service project',
	},
	fields: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.fields',
		defaultMessage: 'Fields',
		description: 'Settings navigation menu link for a service project',
	},
	versions: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.versions',
		defaultMessage: 'Versions',
		description: 'Settings navigation menu link for a service project',
	},
	components: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.components',
		defaultMessage: 'Components',
		description: 'Settings navigation menu link for a service project',
	},
	permissions: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.permissions',
		defaultMessage: 'Permissions',
		description: 'Settings navigation menu link for a service project',
	},
	issueSecurity: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-security',
		defaultMessage: 'Issue security',
		description: 'Settings navigation menu link for a service project',
	},
	notifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.notifications',
		defaultMessage: 'Notifications',
		description: 'Settings navigation menu link for a service project',
	},
	projectAutomation: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.project-automation',
		defaultMessage: 'Project Automation',
		description: 'Settings navigation menu link for a software project',
	},
	hipChat: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.hip-chat',
		defaultMessage: 'HipChat integration',
		description: 'Settings navigation menu link for a service project',
	},
	issueCollectors: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-collectors',
		defaultMessage: 'Issue collectors',
		description: 'Settings navigation menu link for a service project',
	},
	features: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.features',
		defaultMessage: 'Features',
		description: 'Settings navigation menu link for a service project',
	},
	requestTypes: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.request-types',
		defaultMessage: 'Request types',
		description: 'Settings navigation menu link for a service project',
	},
	workCategories: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.work-categories',
		defaultMessage: 'Work categories',
		description: 'Settings navigation menu link for a service project',
	},
	customerPermissions: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.customer-permissions',
		defaultMessage: 'Customer permissions',
		description: 'Settings navigation menu link for a service project',
	},
	languageSupport: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.language-support',
		defaultMessage: 'Language support',
		description: 'Settings navigation menu link for a service project',
	},
	portalSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.portal-settings',
		defaultMessage: 'Portal settings',
		description: 'Settings navigation menu link for a service project',
	},
	emailRequests: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.email-requests',
		defaultMessage: 'Email requests',
		description: 'Settings navigation menu link for a service project',
	},
	customerNotifications: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.customer-notifications',
		defaultMessage: 'Customer notifications',
		description: 'Settings navigation menu link for a service project',
	},
	widget: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.widget',
		defaultMessage: 'Widget',
		description: 'Settings navigation menu link for a service project',
	},
	satisfactionSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.satisfaction-settings',
		defaultMessage: 'Satisfaction settings',
		description: 'Settings navigation menu link for a service project',
	},
	knowledgeBase: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.knowledge-base',
		defaultMessage: 'Knowledge base',
		description: 'Settings navigation menu link for a service project',
	},
	sla: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.sla',
		defaultMessage: 'SLAs',
		description: 'Settings navigation menu link for a service project',
	},
	automation: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.automation',
		defaultMessage: 'Automation',
		description: 'Settings navigation menu link for a service project',
	},
	playbooks: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.playbooks',
		defaultMessage: 'Playbooks',
		description: 'Settings navigation menu link for a service project',
	},
	playbooksNewLozenge: {
		id: 'navigation-apps-sidebar-nav4-jsm-cmp-project-settings.playbooks.new-lozenge-label',
		defaultMessage: 'NEW',
		description:
			'The label of lozenge that indicates Playbooks is a new feature. Displayed all in capital letters',
	},
	journeys: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.journeys',
		defaultMessage: 'Journeys',
		description: 'Settings navigation menu link for a journey builder',
	},
	devtools: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.devtools',
		defaultMessage: 'Development tools',
		description: 'Settings navigation menu link to the development tools page',
	},
	jsdAppDiscovery: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.jsd-app-discovery',
		defaultMessage: 'Apps',
		description: 'Settings navigation menu link for a service project',
	},
	jsdIncidentManagement: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.jsd-incident-management',
		defaultMessage: 'Incident management',
		description: 'Settings navigation menu link for a service project',
	},
	jsdChangeManagement: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.jsd-change-management',
		defaultMessage: 'Change management',
		description: 'Settings navigation menu link for a service project',
	},
	title: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.title',
		defaultMessage: 'Project settings',
		description: 'Title for project settings navigation panel',
	},
	itemBack: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.item-back',
		defaultMessage: 'Back to project settings',
		description: '"Back" menu item.',
	},
	goToSettings: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.go-to-settings',
		defaultMessage: 'Back to settings',
		description: 'Go back to settings from request types categories subnav in service project.',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	'practice_change-management': {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.indicen-dfd',
		defaultMessage: 'Changes',
		description:
			'A nav item to go to the page to configure request types with the ITSM category "Changes".',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	'practice_incident-management': {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.practice-incident-management',
		defaultMessage: 'Incidents',
		description:
			'A nav item to go to the page to configure request types with the ITSM category "Incidents".',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	'practice_post-incident-review': {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.practice-post-incident-review',
		defaultMessage: 'Post-incident reviews',
		description:
			'A nav item to go to the page to configure request types with the ITSM category "Post incident reviews".',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	'practice_developer-escalation': {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.practice-developer-escalation',
		defaultMessage: 'Developer escalations',
		description:
			'A nav item to go to the page to configure request types with the category "Developer escalations".',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	'practice_problem-management': {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.practice-problem-management',
		defaultMessage: 'Problems',
		description:
			'A nav item to go to the page to configure request types with the ITSM category "Problems".',
	},
	// eslint-disable-next-line jira/i18n/id-named-by-package -- PLEASE FIX THIS SUPPRESSION
	'practice_service-request': {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.practice-service-request',
		defaultMessage: 'Service requests',
		description:
			'A nav item to go to the page to configure request types with the ITSM category "Service requests".',
	},
	chat: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.chat',
		defaultMessage: 'Chat',
		description: 'Settings navigation menu link for a service project',
	},
	unassigned: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.unassigned',
		defaultMessage: 'Unassigned',
		description: 'Nav item label for request types that is not assigned to any ITSM practices',
	},
	newLozenge: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.new-lozenge',
		defaultMessage: 'New',
		description:
			'Small lozenge that appears to the right of the nav item, indicating a new feature.',
	},
	forms: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.forms',
		defaultMessage: 'Forms',
		description: 'Nav item label for configuring forms of a servicedesk project',
	},
	externalLinks: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.external-links',
		defaultMessage: 'External resources',
		description: 'Nav item label for configuring external resources of a servicedesk project',
	},
	dataClassificationsNonFinal: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.data-classifications-non-final',
		defaultMessage: 'Data classification',
		description: 'data classifications settings navigation menu link for a service project',
	},
	accessGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.access-group',
		defaultMessage: 'Access',
		description: 'Nav group label for access related pages',
	},
	requestsManagementGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.requests-management-group',
		defaultMessage: 'Request management',
		description: 'Nav group label for request management related pages',
	},
	channelsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.channels-group',
		defaultMessage: 'Channels & self service',
		description: 'Nav group label for channels related pages',
	},
	notificationsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.notifications-group',
		defaultMessage: 'Notifications',
		description: 'Nav group label for notifications related pages',
	},
	integrationsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.integrations-group',
		defaultMessage: 'Apps',
		description: 'Nav group label for integrations related pages',
	},
	operationsGroup: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.operations-group',
		defaultMessage: 'Operations',
		description: 'Nav group label for operations related pages',
	},
	issueTypesIssueTerminologyRefreshM4: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-types-issue-terminology-refresh-m4',
		defaultMessage: 'Work types',
		description: 'Settings navigation menu link for a service project',
	},
	issueLayoutIssueTerminologyRefreshM4: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-layout-issue-terminology-refresh-m4',
		defaultMessage: 'Work item layout',
		description: 'Settings navigation menu link for a service project',
	},
	issueSecurityIssueTerminologyRefreshM4: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-security-issue-terminology-refresh-m4',
		defaultMessage: 'Work item security',
		description: 'Settings navigation menu link for a service project',
	},
	issueCollectorsIssueTerminologyRefreshM4: {
		id: 'spa-apps-sidebar-servicedesk.common.settings-classic.issue-collectors-issue-terminology-refresh-m4',
		defaultMessage: 'Work item collectors',
		description: 'Settings navigation menu link for a service project',
	},
});
